"use client";

import React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
const testimonials = [{
  id: 2,
  quoteFr: "\"A Jornada Prateada nos dá a oportunidade de reflexão, de atualizações do mercado de trabalho, além de muitas trocas sobre nosso atual momento, propósito, crenças, expectativas, sonhos e planos! Um momento único e que vale à pena a experiência\"\xA0",
  quoteAr: "لقد سمح لي دعم القيادة التنفيذية بالتنقل عبر التحولات المعقدة بثقة ووضوح استراتيجي مطلق.",
  name: "CRISTIANA LOYOLA",
  roleFr: "VP de Estratégia, Finanças S.A.",
  roleAr: "نائب رئيس الاستراتيجية، فينانساس",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/executive_heloisa_portrait.png"
}, {
  id: 3,
  quoteFr: "“A Jornada Prateada é um instrumento valioso para reavaliar sua história, seus talentos e conhecimentos, para ajustar sua bússola interna para uma nova fase do seu caminho”",
  quoteAr: "تجربة توجيه رفيعة المستوى تركز على ما يهم حقاً: إرث وتأثير القائد الحديث.",
  name: "MARCOS CAETANO",
  roleFr: "CEO, Inovação Corporativa",
  roleAr: "الرئيس التنفيذي، الابتكار المؤسسي",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/executive_carlos_portrait.png"
}];
export default function SuccessStories() {
  return <section data-section-id="224334" id="executivenetworktestimonials" className="relative bg-background text-foreground py-24 md:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-[0.03] bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/masterpro_pattern_texture.png)] bg-repeat bg-[length:150px_150px] pointer-events-none" aria-hidden="true" />

      <div className="container mx-auto px-4 md:px-8 max-w-6xl relative z-10">
        <div className="flex flex-col items-center text-center mb-16 md:mb-24">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-primary tracking-tighter flex flex-col md:flex-row items-center gap-2 md:gap-4">
            <span>Rede MASTERPRO+</span>
            
            
          </h2>
          <p className="mt-6 text-muted-foreground text-lg md:text-xl max-w-2xl font-default font-normal leading-relaxed">
            Executivos, líderes e especialistas conectados por desenvolvimento contínuo, networking estratégico e novas oportunidades.
          </p>
          <div className="h-1 w-24 bg-primary mt-8 rounded-none" />
        </div>

        <Carousel opts={{
        loop: true,
        align: "center"
      }} className="w-full">
          <CarouselContent>
            {testimonials.map((item, i) => <CarouselItem key={item.id} data-index={i}>
                <Card className="rounded-none border-none shadow-none bg-transparent">
                  <CardContent className="p-0 flex flex-col items-center text-center">
                    
                    
                    <div className="space-y-8 mb-12 max-w-4xl mx-auto px-4">
                      <p className="font-serif text-2xl md:text-4xl text-foreground leading-relaxed italic">
                        "{item.quoteFr}"
                      </p>
                      
                    </div>

                    <div className="flex flex-col items-center gap-5 mt-4">
                      <div className="relative size-16 md:size-20 shrink-0">
                        <img src={item.image} alt={item.name} className="size-full object-cover rounded-full grayscale hover:grayscale-0 transition-all duration-500" />
                        {}
                        <div className="absolute inset-0 bg-primary/10 rounded-full mix-blend-multiply" />
                      </div>
                      <div className="space-y-1">
                        <h3 className="font-default font-bold uppercase tracking-widest">
                          {item.name}
                        </h3>
                        <p className="text-sm font-default tracking-wide">
                          {item.roleFr} <span className="mx-1 text-border">|</span> 
                        </p>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="flex justify-center md:justify-end gap-3 mt-16 md:mt-8 md:pr-8">
            <CarouselPrevious className="static translate-y-0 left-auto right-auto rounded-none border-primary text-primary hover:bg-primary hover:text-primary-foreground size-12 transition-all duration-300 shadow-sm" variant="outline" />
            <CarouselNext className="static translate-y-0 left-auto right-auto rounded-none border-primary text-primary hover:bg-primary hover:text-primary-foreground size-12 transition-all duration-300 shadow-sm" variant="outline" />
          </div>
        </Carousel>
      </div>
    </section>;
}